import lazyScreen from '../utils/lazyScreen';
const WFApprovalPolicys = lazyScreen(() => import('../pages/wf/WFApprovalPolicys/index.js'), 'pages/wf/WFApprovalPolicys/index.js');
const WFApprovalPolicy = lazyScreen(() => import('../pages/wf/WFApprovalPolicy/index.js'), 'pages/wf/WFApprovalPolicy/index.js');
const WFApprovalPendings = lazyScreen(() => import('../pages/wf/WFApprovalPendings/index.js'), 'pages/wf/WFApprovalPendings/index.js');


export default [
    { path: '/wf/WFApprovalPolicys', component: WFApprovalPolicys },
    { path: '/wf/WFApprovalPolicy/:code', component: WFApprovalPolicy },
    { path: '/wf/WFApprovalPendings', component: WFApprovalPendings }
];
